// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WelcomeRouteImport } from './routes/welcome'
import { Route as ViralCardsRouteImport } from './routes/viral-cards'
import { Route as VerifyEmailRouteImport } from './routes/verify-email'
import { Route as ValidarVoucherRouteImport } from './routes/validar-voucher'
import { Route as TerminosRouteImport } from './routes/terminos'
import { Route as TenantPortalRouteImport } from './routes/tenant-portal'
import { Route as SuperadminAccessRouteImport } from './routes/superadmin-access'
import { Route as SocialRouteImport } from './routes/social'
import { Route as ShowcaseRouteImport } from './routes/showcase'
import { Route as RetosRouteImport } from './routes/retos'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as RegistroRouteImport } from './routes/registro'
import { Route as RachaRouteImport } from './routes/racha'
import { Route as QuinielasRouteImport } from './routes/quinielas'
import { Route as PrivacidadRouteImport } from './routes/privacidad'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as NationWarsRouteImport } from './routes/nation-wars'
import { Route as MiPlanRouteImport } from './routes/mi-plan'
import { Route as MiIdentidadRouteImport } from './routes/mi-identidad'
import { Route as MexicoRouteImport } from './routes/mexico'
import { Route as MediaBlitzRouteImport } from './routes/media-blitz'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndiaRouteImport } from './routes/india'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as ElegirRolRouteImport } from './routes/elegir-rol'
import { Route as CreatorStudioRouteImport } from './routes/creator-studio'
import { Route as CreatorKitRouteImport } from './routes/creator-kit'
import { Route as CorporateAccessRouteImport } from './routes/corporate-access'
import { Route as BrasilRouteImport } from './routes/brasil'
import { Route as AyudaRouteImport } from './routes/ayuda'
import { Route as ArgentinaRouteImport } from './routes/argentina'
import { Route as AmbassadorsRouteImport } from './routes/ambassadors'
import { Route as AdministracionRouteImport } from './routes/administracion'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as WcSlugRouteImport } from './routes/wc.$slug'
import { Route as SNationRouteImport } from './routes/s.$nation'
import { Route as RCodeRouteImport } from './routes/r.$code'
import { Route as ChallengeCodeRouteImport } from './routes/challenge.$code'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AjustesTemaRouteImport } from './routes/ajustes.tema'
import { Route as AjustesPrivacidadRouteImport } from './routes/ajustes.privacidad'
import { Route as PartnersRegisterRouteImport } from './routes/partners.register'
import { Route as PartnersLoginRouteImport } from './routes/partners.login'
import { Route as MexicoIndexRouteImport } from './routes/mexico.index'
import { Route as MexicoTudnRouteImport } from './routes/mexico.tudn'
import { Route as MexicoTelevisaRouteImport } from './routes/mexico.televisa'
import { Route as MexicoAztecaRouteImport } from './routes/mexico.azteca'
import { Route as IndiaIndexRouteImport } from './routes/india.index'
import { Route as BrasilIndexRouteImport } from './routes/brasil.index'
import { Route as BrasilSportvRouteImport } from './routes/brasil.sportv'
import { Route as BrasilNSportsRouteImport } from './routes/brasil.n-sports'
import { Route as BrasilGloboplayRouteImport } from './routes/brasil.globoplay'
import { Route as BrasilGloboRouteImport } from './routes/brasil.globo'
import { Route as BrasilCazetvRouteImport } from './routes/brasil.cazetv'
import { Route as ArgentinaIndexRouteImport } from './routes/argentina.index'
import { Route as AdminWorldDominationRouteImport } from './routes/admin.world-domination'
import { Route as AdminWorldCupWarroomRouteImport } from './routes/admin.world-cup-warroom'
import { Route as AdminSupabaseOwnerAuditRouteImport } from './routes/admin.supabase-owner-audit'
import { Route as AdminStrategicAiRouteImport } from './routes/admin.strategic-ai'
import { Route as AdminStorageHealthRouteImport } from './routes/admin.storage-health'
import { Route as AdminSponsorsRouteImport } from './routes/admin.sponsors'
import { Route as AdminSponsorAnalyticsRouteImport } from './routes/admin.sponsor-analytics'
import { Route as AdminResilienceRouteImport } from './routes/admin.resilience'
import { Route as AdminQaReportRouteImport } from './routes/admin.qa-report'
import { Route as AdminPredictionEngineRouteImport } from './routes/admin.prediction-engine'
import { Route as AdminPosthogDiagnosticsRouteImport } from './routes/admin.posthog-diagnostics'
import { Route as AdminMexicoDominationRouteImport } from './routes/admin.mexico-domination'
import { Route as AdminMarketDominationRouteImport } from './routes/admin.market-domination'
import { Route as AdminIndiaDominationRouteImport } from './routes/admin.india-domination'
import { Route as AdminExecutiveCommandCenterRouteImport } from './routes/admin.executive-command-center'
import { Route as AdminExecutiveAiCommandCenterRouteImport } from './routes/admin.executive-ai-command-center'
import { Route as AdminCountryGrowthRouteImport } from './routes/admin.country-growth'
import { Route as AdminConversionEngineRouteImport } from './routes/admin.conversion-engine'
import { Route as AdminCommercialIntelligenceRouteImport } from './routes/admin.commercial-intelligence'
import { Route as AdminBrasilGrowthRouteImport } from './routes/admin.brasil-growth'
import { Route as AdminBrasilDominationRouteImport } from './routes/admin.brasil-domination'
import { Route as AdminAntiFraudRouteImport } from './routes/admin.anti-fraud'
import { Route as MexicoInfluencerSlugRouteImport } from './routes/mexico.influencer.$slug'
import { Route as IndiaInfluencerSlugRouteImport } from './routes/india.influencer.$slug'
import { Route as BrasilInfluencerSlugRouteImport } from './routes/brasil.influencer.$slug'
import { Route as ArgentinaInfluencerSlugRouteImport } from './routes/argentina.influencer.$slug'

const WelcomeRoute = WelcomeRouteImport.update({
            id: '/welcome',path: '/welcome',getParentRoute: () => rootRouteImport
          })
const ViralCardsRoute = ViralCardsRouteImport.update({
            id: '/viral-cards',path: '/viral-cards',getParentRoute: () => rootRouteImport
          })
const VerifyEmailRoute = VerifyEmailRouteImport.update({
            id: '/verify-email',path: '/verify-email',getParentRoute: () => rootRouteImport
          })
const ValidarVoucherRoute = ValidarVoucherRouteImport.update({
            id: '/validar-voucher',path: '/validar-voucher',getParentRoute: () => rootRouteImport
          })
const TerminosRoute = TerminosRouteImport.update({
            id: '/terminos',path: '/terminos',getParentRoute: () => rootRouteImport
          })
const TenantPortalRoute = TenantPortalRouteImport.update({
            id: '/tenant-portal',path: '/tenant-portal',getParentRoute: () => rootRouteImport
          })
const SuperadminAccessRoute = SuperadminAccessRouteImport.update({
            id: '/superadmin-access',path: '/superadmin-access',getParentRoute: () => rootRouteImport
          })
const SocialRoute = SocialRouteImport.update({
            id: '/social',path: '/social',getParentRoute: () => rootRouteImport
          })
const ShowcaseRoute = ShowcaseRouteImport.update({
            id: '/showcase',path: '/showcase',getParentRoute: () => rootRouteImport
          })
const RetosRoute = RetosRouteImport.update({
            id: '/retos',path: '/retos',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const RegistroRoute = RegistroRouteImport.update({
            id: '/registro',path: '/registro',getParentRoute: () => rootRouteImport
          })
const RachaRoute = RachaRouteImport.update({
            id: '/racha',path: '/racha',getParentRoute: () => rootRouteImport
          })
const QuinielasRoute = QuinielasRouteImport.update({
            id: '/quinielas',path: '/quinielas',getParentRoute: () => rootRouteImport
          })
const PrivacidadRoute = PrivacidadRouteImport.update({
            id: '/privacidad',path: '/privacidad',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const OnboardingRoute = OnboardingRouteImport.update({
            id: '/onboarding',path: '/onboarding',getParentRoute: () => rootRouteImport
          })
const NationWarsRoute = NationWarsRouteImport.update({
            id: '/nation-wars',path: '/nation-wars',getParentRoute: () => rootRouteImport
          })
const MiPlanRoute = MiPlanRouteImport.update({
            id: '/mi-plan',path: '/mi-plan',getParentRoute: () => rootRouteImport
          })
const MiIdentidadRoute = MiIdentidadRouteImport.update({
            id: '/mi-identidad',path: '/mi-identidad',getParentRoute: () => rootRouteImport
          })
const MexicoRoute = MexicoRouteImport.update({
            id: '/mexico',path: '/mexico',getParentRoute: () => rootRouteImport
          })
const MediaBlitzRoute = MediaBlitzRouteImport.update({
            id: '/media-blitz',path: '/media-blitz',getParentRoute: () => rootRouteImport
          })
const LogoutRoute = LogoutRouteImport.update({
            id: '/logout',path: '/logout',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const IndiaRoute = IndiaRouteImport.update({
            id: '/india',path: '/india',getParentRoute: () => rootRouteImport
          })
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
            id: '/forgot-password',path: '/forgot-password',getParentRoute: () => rootRouteImport
          })
const ElegirRolRoute = ElegirRolRouteImport.update({
            id: '/elegir-rol',path: '/elegir-rol',getParentRoute: () => rootRouteImport
          })
const CreatorStudioRoute = CreatorStudioRouteImport.update({
            id: '/creator-studio',path: '/creator-studio',getParentRoute: () => rootRouteImport
          })
const CreatorKitRoute = CreatorKitRouteImport.update({
            id: '/creator-kit',path: '/creator-kit',getParentRoute: () => rootRouteImport
          })
const CorporateAccessRoute = CorporateAccessRouteImport.update({
            id: '/corporate-access',path: '/corporate-access',getParentRoute: () => rootRouteImport
          })
const BrasilRoute = BrasilRouteImport.update({
            id: '/brasil',path: '/brasil',getParentRoute: () => rootRouteImport
          })
const AyudaRoute = AyudaRouteImport.update({
            id: '/ayuda',path: '/ayuda',getParentRoute: () => rootRouteImport
          })
const ArgentinaRoute = ArgentinaRouteImport.update({
            id: '/argentina',path: '/argentina',getParentRoute: () => rootRouteImport
          })
const AmbassadorsRoute = AmbassadorsRouteImport.update({
            id: '/ambassadors',path: '/ambassadors',getParentRoute: () => rootRouteImport
          })
const AdministracionRoute = AdministracionRouteImport.update({
            id: '/administracion',path: '/administracion',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const WcSlugRoute = WcSlugRouteImport.update({
            id: '/wc/$slug',path: '/wc/$slug',getParentRoute: () => rootRouteImport
          })
const SNationRoute = SNationRouteImport.update({
            id: '/s/$nation',path: '/s/$nation',getParentRoute: () => rootRouteImport
          })
const RCodeRoute = RCodeRouteImport.update({
            id: '/r/$code',path: '/r/$code',getParentRoute: () => rootRouteImport
          })
const ChallengeCodeRoute = ChallengeCodeRouteImport.update({
            id: '/challenge/$code',path: '/challenge/$code',getParentRoute: () => rootRouteImport
          })
const AuthCallbackRoute = AuthCallbackRouteImport.update({
            id: '/auth/callback',path: '/auth/callback',getParentRoute: () => rootRouteImport
          })
const AjustesTemaRoute = AjustesTemaRouteImport.update({
            id: '/ajustes/tema',path: '/ajustes/tema',getParentRoute: () => rootRouteImport
          })
const AjustesPrivacidadRoute = AjustesPrivacidadRouteImport.update({
            id: '/ajustes/privacidad',path: '/ajustes/privacidad',getParentRoute: () => rootRouteImport
          })
const PartnersRegisterRoute = PartnersRegisterRouteImport.update({
            id: '/register',path: '/register',getParentRoute: () => PartnersRoute
          })
const PartnersLoginRoute = PartnersLoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => PartnersRoute
          })
const MexicoIndexRoute = MexicoIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MexicoRoute
          })
const MexicoTudnRoute = MexicoTudnRouteImport.update({
            id: '/tudn',path: '/tudn',getParentRoute: () => MexicoRoute
          })
const MexicoTelevisaRoute = MexicoTelevisaRouteImport.update({
            id: '/televisa',path: '/televisa',getParentRoute: () => MexicoRoute
          })
const MexicoAztecaRoute = MexicoAztecaRouteImport.update({
            id: '/azteca',path: '/azteca',getParentRoute: () => MexicoRoute
          })
const IndiaIndexRoute = IndiaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => IndiaRoute
          })
const BrasilIndexRoute = BrasilIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BrasilRoute
          })
const BrasilSportvRoute = BrasilSportvRouteImport.update({
            id: '/sportv',path: '/sportv',getParentRoute: () => BrasilRoute
          })
const BrasilNSportsRoute = BrasilNSportsRouteImport.update({
            id: '/n-sports',path: '/n-sports',getParentRoute: () => BrasilRoute
          })
const BrasilGloboplayRoute = BrasilGloboplayRouteImport.update({
            id: '/globoplay',path: '/globoplay',getParentRoute: () => BrasilRoute
          })
const BrasilGloboRoute = BrasilGloboRouteImport.update({
            id: '/globo',path: '/globo',getParentRoute: () => BrasilRoute
          })
const BrasilCazetvRoute = BrasilCazetvRouteImport.update({
            id: '/cazetv',path: '/cazetv',getParentRoute: () => BrasilRoute
          })
const ArgentinaIndexRoute = ArgentinaIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ArgentinaRoute
          })
const AdminWorldDominationRoute = AdminWorldDominationRouteImport.update({
            id: '/world-domination',path: '/world-domination',getParentRoute: () => AdminRoute
          })
const AdminWorldCupWarroomRoute = AdminWorldCupWarroomRouteImport.update({
            id: '/world-cup-warroom',path: '/world-cup-warroom',getParentRoute: () => AdminRoute
          })
const AdminSupabaseOwnerAuditRoute = AdminSupabaseOwnerAuditRouteImport.update({
            id: '/supabase-owner-audit',path: '/supabase-owner-audit',getParentRoute: () => AdminRoute
          })
const AdminStrategicAiRoute = AdminStrategicAiRouteImport.update({
            id: '/strategic-ai',path: '/strategic-ai',getParentRoute: () => AdminRoute
          })
const AdminStorageHealthRoute = AdminStorageHealthRouteImport.update({
            id: '/storage-health',path: '/storage-health',getParentRoute: () => AdminRoute
          })
const AdminSponsorsRoute = AdminSponsorsRouteImport.update({
            id: '/sponsors',path: '/sponsors',getParentRoute: () => AdminRoute
          })
const AdminSponsorAnalyticsRoute = AdminSponsorAnalyticsRouteImport.update({
            id: '/sponsor-analytics',path: '/sponsor-analytics',getParentRoute: () => AdminRoute
          })
const AdminResilienceRoute = AdminResilienceRouteImport.update({
            id: '/resilience',path: '/resilience',getParentRoute: () => AdminRoute
          })
const AdminQaReportRoute = AdminQaReportRouteImport.update({
            id: '/qa-report',path: '/qa-report',getParentRoute: () => AdminRoute
          })
const AdminPredictionEngineRoute = AdminPredictionEngineRouteImport.update({
            id: '/prediction-engine',path: '/prediction-engine',getParentRoute: () => AdminRoute
          })
const AdminPosthogDiagnosticsRoute = AdminPosthogDiagnosticsRouteImport.update({
            id: '/posthog-diagnostics',path: '/posthog-diagnostics',getParentRoute: () => AdminRoute
          })
const AdminMexicoDominationRoute = AdminMexicoDominationRouteImport.update({
            id: '/mexico-domination',path: '/mexico-domination',getParentRoute: () => AdminRoute
          })
const AdminMarketDominationRoute = AdminMarketDominationRouteImport.update({
            id: '/market-domination',path: '/market-domination',getParentRoute: () => AdminRoute
          })
const AdminIndiaDominationRoute = AdminIndiaDominationRouteImport.update({
            id: '/india-domination',path: '/india-domination',getParentRoute: () => AdminRoute
          })
const AdminExecutiveCommandCenterRoute = AdminExecutiveCommandCenterRouteImport.update({
            id: '/executive-command-center',path: '/executive-command-center',getParentRoute: () => AdminRoute
          })
const AdminExecutiveAiCommandCenterRoute = AdminExecutiveAiCommandCenterRouteImport.update({
            id: '/executive-ai-command-center',path: '/executive-ai-command-center',getParentRoute: () => AdminRoute
          })
const AdminCountryGrowthRoute = AdminCountryGrowthRouteImport.update({
            id: '/country-growth',path: '/country-growth',getParentRoute: () => AdminRoute
          })
const AdminConversionEngineRoute = AdminConversionEngineRouteImport.update({
            id: '/conversion-engine',path: '/conversion-engine',getParentRoute: () => AdminRoute
          })
const AdminCommercialIntelligenceRoute = AdminCommercialIntelligenceRouteImport.update({
            id: '/commercial-intelligence',path: '/commercial-intelligence',getParentRoute: () => AdminRoute
          })
const AdminBrasilGrowthRoute = AdminBrasilGrowthRouteImport.update({
            id: '/brasil-growth',path: '/brasil-growth',getParentRoute: () => AdminRoute
          })
const AdminBrasilDominationRoute = AdminBrasilDominationRouteImport.update({
            id: '/brasil-domination',path: '/brasil-domination',getParentRoute: () => AdminRoute
          })
const AdminAntiFraudRoute = AdminAntiFraudRouteImport.update({
            id: '/anti-fraud',path: '/anti-fraud',getParentRoute: () => AdminRoute
          })
const MexicoInfluencerSlugRoute = MexicoInfluencerSlugRouteImport.update({
            id: '/influencer/$slug',path: '/influencer/$slug',getParentRoute: () => MexicoRoute
          })
const IndiaInfluencerSlugRoute = IndiaInfluencerSlugRouteImport.update({
            id: '/influencer/$slug',path: '/influencer/$slug',getParentRoute: () => IndiaRoute
          })
const BrasilInfluencerSlugRoute = BrasilInfluencerSlugRouteImport.update({
            id: '/influencer/$slug',path: '/influencer/$slug',getParentRoute: () => BrasilRoute
          })
const ArgentinaInfluencerSlugRoute = ArgentinaInfluencerSlugRouteImport.update({
            id: '/influencer/$slug',path: '/influencer/$slug',getParentRoute: () => ArgentinaRoute
          })





const AdminRouteChildren = {
  AdminAntiFraudRoute: AdminAntiFraudRoute,AdminBrasilDominationRoute: AdminBrasilDominationRoute,AdminBrasilGrowthRoute: AdminBrasilGrowthRoute,AdminCommercialIntelligenceRoute: AdminCommercialIntelligenceRoute,AdminConversionEngineRoute: AdminConversionEngineRoute,AdminCountryGrowthRoute: AdminCountryGrowthRoute,AdminExecutiveAiCommandCenterRoute: AdminExecutiveAiCommandCenterRoute,AdminExecutiveCommandCenterRoute: AdminExecutiveCommandCenterRoute,AdminIndiaDominationRoute: AdminIndiaDominationRoute,AdminMarketDominationRoute: AdminMarketDominationRoute,AdminMexicoDominationRoute: AdminMexicoDominationRoute,AdminPosthogDiagnosticsRoute: AdminPosthogDiagnosticsRoute,AdminPredictionEngineRoute: AdminPredictionEngineRoute,AdminQaReportRoute: AdminQaReportRoute,AdminResilienceRoute: AdminResilienceRoute,AdminSponsorAnalyticsRoute: AdminSponsorAnalyticsRoute,AdminSponsorsRoute: AdminSponsorsRoute,AdminStorageHealthRoute: AdminStorageHealthRoute,AdminStrategicAiRoute: AdminStrategicAiRoute,AdminSupabaseOwnerAuditRoute: AdminSupabaseOwnerAuditRoute,AdminWorldCupWarroomRoute: AdminWorldCupWarroomRoute,AdminWorldDominationRoute: AdminWorldDominationRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const ArgentinaRouteChildren = {
  ArgentinaIndexRoute: ArgentinaIndexRoute,ArgentinaInfluencerSlugRoute: ArgentinaInfluencerSlugRoute
}

const ArgentinaRouteWithChildren = ArgentinaRoute._addFileChildren(ArgentinaRouteChildren)




const BrasilRouteChildren = {
  BrasilCazetvRoute: BrasilCazetvRoute,BrasilGloboRoute: BrasilGloboRoute,BrasilGloboplayRoute: BrasilGloboplayRoute,BrasilNSportsRoute: BrasilNSportsRoute,BrasilSportvRoute: BrasilSportvRoute,BrasilIndexRoute: BrasilIndexRoute,BrasilInfluencerSlugRoute: BrasilInfluencerSlugRoute
}

const BrasilRouteWithChildren = BrasilRoute._addFileChildren(BrasilRouteChildren)




const IndiaRouteChildren = {
  IndiaIndexRoute: IndiaIndexRoute,IndiaInfluencerSlugRoute: IndiaInfluencerSlugRoute
}

const IndiaRouteWithChildren = IndiaRoute._addFileChildren(IndiaRouteChildren)




const MexicoRouteChildren = {
  MexicoAztecaRoute: MexicoAztecaRoute,MexicoTelevisaRoute: MexicoTelevisaRoute,MexicoTudnRoute: MexicoTudnRoute,MexicoIndexRoute: MexicoIndexRoute,MexicoInfluencerSlugRoute: MexicoInfluencerSlugRoute
}

const MexicoRouteWithChildren = MexicoRoute._addFileChildren(MexicoRouteChildren)




const PartnersRouteChildren = {
  PartnersLoginRoute: PartnersLoginRoute,PartnersRegisterRoute: PartnersRegisterRoute
}

const PartnersRouteWithChildren = PartnersRoute._addFileChildren(PartnersRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AdminRoute: AdminRouteWithChildren,AdministracionRoute: AdministracionRoute,AmbassadorsRoute: AmbassadorsRoute,ArgentinaRoute: ArgentinaRouteWithChildren,AyudaRoute: AyudaRoute,BrasilRoute: BrasilRouteWithChildren,CorporateAccessRoute: CorporateAccessRoute,CreatorKitRoute: CreatorKitRoute,CreatorStudioRoute: CreatorStudioRoute,ElegirRolRoute: ElegirRolRoute,ForgotPasswordRoute: ForgotPasswordRoute,IndiaRoute: IndiaRouteWithChildren,LoginRoute: LoginRoute,LogoutRoute: LogoutRoute,MediaBlitzRoute: MediaBlitzRoute,MexicoRoute: MexicoRouteWithChildren,MiIdentidadRoute: MiIdentidadRoute,MiPlanRoute: MiPlanRoute,NationWarsRoute: NationWarsRoute,OnboardingRoute: OnboardingRoute,PartnersRoute: PartnersRouteWithChildren,PrivacidadRoute: PrivacidadRoute,QuinielasRoute: QuinielasRoute,RachaRoute: RachaRoute,RegistroRoute: RegistroRoute,ResetPasswordRoute: ResetPasswordRoute,RetosRoute: RetosRoute,ShowcaseRoute: ShowcaseRoute,SocialRoute: SocialRoute,SuperadminAccessRoute: SuperadminAccessRoute,TenantPortalRoute: TenantPortalRoute,TerminosRoute: TerminosRoute,ValidarVoucherRoute: ValidarVoucherRoute,VerifyEmailRoute: VerifyEmailRoute,ViralCardsRoute: ViralCardsRoute,WelcomeRoute: WelcomeRoute,AjustesPrivacidadRoute: AjustesPrivacidadRoute,AjustesTemaRoute: AjustesTemaRoute,AuthCallbackRoute: AuthCallbackRoute,ChallengeCodeRoute: ChallengeCodeRoute,RCodeRoute: RCodeRoute,SNationRoute: SNationRoute,WcSlugRoute: WcSlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)